import React, {Component} from 'react'
import {Dropdown, Form, Icon, Label, TextArea} from 'semantic-ui-react'
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'
import ReactMarkdown from 'react-markdown'

const FIELD_CLASS_NAME = 'field';

function Explanation(props) {
    const explanation = props.explanation;
    return (explanation &&
        <p className={'explanation'}><Icon name={'info circle'}/><ReactMarkdown allowedElements={['strong', 'em', 'a']}
                                                                                unwrapDisallowed={true}>{explanation}</ReactMarkdown>
        </p>) || null;
}

function PlaceholderLink(props) {
    const allowPreliminary = props.allowPreliminary;
    if (!allowPreliminary) {
        return null;
    }
    let text = props.preliminary ? 'unmark as preliminary' : 'mark as preliminary';
    return (
        <a onClick={props.onClick}
           style={{cursor: 'pointer', display: 'block', textAlign: 'right'}}>{text}</a>
    )
}

// https://stackoverflow.com/questions/30528482/using-javascripts-date-toisostring-and-ignore-timezone/30528821
// to ignore timezone
if (!Date.prototype.toLocalISOString) {
    (function () {

        function pad(number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }

        Date.prototype.toLocalISOString = function () {
            return this.getFullYear() +
                '-' + pad(this.getMonth() + 1) +
                '-' + pad(this.getDate()) +
                'T00:00:00.000Z';
            // + pad(this.getHours()) +
            // ':' + pad(this.getMinutes()) +
            // ':' + pad(this.getSeconds()) +
            // '.' + (this.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
            // 'Z';
        };

    }());
}

function splitStringsInArray(inputArray, separator) {
    const newValues = [];
    const uniqueValues = new Set();
    inputArray.forEach(function (v) {
        if (v !== undefined && v !== null) {
            if (typeof v === 'string') {
                v.split(separator).forEach(function (t) {
                    t = t.trim();
                    if (!uniqueValues.has(t)) {
                        newValues.push(t);
                        uniqueValues.add(t);
                    }
                });
            } else {
                newValues.push(v);
            }
        }
    });
    return newValues;
};


export class ItemField extends Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.isreadOnly !== nextProps.readOnly ||
            this.props.isObserver !== nextProps.isObserver ||
            this.props.value !== nextProps.value ||
            this.props.preliminary !== nextProps.preliminary ||
            this.props.error !== nextProps.error ||
            this.props.itemKey !== nextProps.itemKey ||
            this.props.preliminarySection !== nextProps.preliminarySection ||
            this.props.loopName !== nextProps.loopName);
    }

    onValueChange = (e, {value}) => {
        if (this.props.readOnly) {
            return;
        }
        const {isObserver, handleChange} = this.props;
        if (!isObserver) {
            if (this.props.type === 'checkbox') {
                value = !this.props.value;
            }
            if (this.props.type === 'number') {
                value = parseInt(value);
            }
            if (this.props.multiple === true && value) {
                const separators = [',', ';'];
                for (let i = 0; i < separators.length; i++) {
                    value = splitStringsInArray(value, separators[i]);
                }
            }
            handleChange(value);
        }
    };
    onTogglePreliminary = () => {
        if (this.props.readOnly) {
            return;
        }
        const {isObserver, togglePreliminary} = this.props;
        if (!isObserver) {
            togglePreliminary();
        }
    };
    onDateChange = (event, newDate) => {
        if (this.props.readOnly) {
            return;
        }
        let value;
        if (newDate?.value === null) {
            value = undefined;
        } else {
            value = newDate.value.toLocalISOString();
        }
        if (value !== this.props.value) {
            this.onValueChange(null, {value});
        }
    };

    onValueAdded = (e, {value}) => {
        this.props.handleAddition(value);
    };


    render() {
        let {
            error,
            preliminarySection,
            readOnly,
            type,
            options,
            label,
            defaultValue,
            value,
            multiple,
            allowAdditions,
            allowPreliminary,
            preliminary,
            min,
            itemKey,
            explanation,
            optional,
            focused
        } = this.props;
        if ((value === undefined || value === null) && defaultValue) {
            value = defaultValue;
            this.onValueChange(null, {value});
        }
        const uniqueOptionsValues = new Set();
        if (options) {
            options.map((option) => (
                uniqueOptionsValues.add(option.value)
            ));
        }
        const labelClassName = optional ? 'optional-field' : 'mandatory-field';
        if (error) {
            error = error.text;
        }
        if (type === "yesno") {
            type = "radio";
            options = [
                {key: itemKey + "y", text: "yes", value: 1},
                {key: itemKey + "n", text: "no", value: 0},
            ]
        }
        let className = FIELD_CLASS_NAME;
        if (preliminarySection || preliminary === true) {
            className += ' preliminary'
        }
        switch (type) {
            case "noInput":
                const content = label || '' + error || '';
                return (
                    <div className={className}>
                        <p><ReactMarkdown allowedElements={['strong', 'em', 'a']}
                                          unwrapDisallowed={true}>{content}</ReactMarkdown></p>
                    </div>
                );
            case "radio":
                return (
                    <div className={className}>
                        <label className={labelClassName}><ReactMarkdown allowedElements={['strong', 'em', 'a']}
                                                                         unwrapDisallowed={true}>{label}</ReactMarkdown></label><Explanation
                        explanation={explanation}/>
                        {options.map((option) => (
                            <Form.Radio autoFocus={focused} error={error} key={itemKey + option.key} label={option.text}
                                        value={option.value}
                                        checked={value === option.value}
                                        onChange={this.onValueChange.bind(this)}/>
                        ))}
                        {!preliminarySection &&
                        <PlaceholderLink allowPreliminary={allowPreliminary} preliminary={preliminary}
                                         onClick={this.onTogglePreliminary.bind(this)}/>}
                    </div>
                );
            case "checkbox":
                return (
                    <div className={className}>
                        <Form.Checkbox autoFocus={focused} error={error} label={label}
                                       checked={value}
                                       onChange={this.onValueChange.bind(this)}/>
                        <Explanation explanation={explanation}/>
                        {!preliminarySection &&
                        <PlaceholderLink allowPreliminary={allowPreliminary} preliminary={preliminary}
                                         onClick={this.onTogglePreliminary.bind(this)}/>}
                    </div>
                );
            case "text":
                return (
                    <div className={className}>
                        <label className={labelClassName}><ReactMarkdown allowedElements={['strong', 'em', 'a']}
                                                                         unwrapDisallowed={true}>{label}</ReactMarkdown></label>
                        <Explanation explanation={explanation}/>
                        <Form.Input autoFocus={focused} error={error} value={value || ""}
                                    onChange={this.onValueChange.bind(this)}
                        />
                        {!preliminarySection &&
                        <PlaceholderLink allowPreliminary={allowPreliminary} preliminary={preliminary}
                                         onClick={this.onTogglePreliminary.bind(this)}/>}
                    </div>
                );
            case "number":
                return (
                    <div className={className}>
                        <label className={labelClassName}><ReactMarkdown allowedElements={['strong', 'em', 'a']}
                                                                         unwrapDisallowed={true}>{label}</ReactMarkdown></label>
                        <Explanation explanation={explanation}/>
                        <Form.Input autoFocus={focused} error={error} type="number"
                                    value={value || ""}
                                    min={min || ""}
                                    onChange={this.onValueChange.bind(this)}
                        />
                        {!preliminarySection &&
                        <PlaceholderLink allowPreliminary={allowPreliminary} preliminary={preliminary}
                                         onClick={this.onTogglePreliminary.bind(this)}/>}
                    </div>
                );
            case "textarea":
                return (
                    <div className={className}>
                        <label className={labelClassName}><ReactMarkdown allowedElements={['strong', 'em', 'a']}
                                                                         unwrapDisallowed={true}>{label}</ReactMarkdown></label>
                        <Explanation explanation={explanation}/>
                        <TextArea autoFocus={focused} error={error} value={value || ""}
                                  onChange={this.onValueChange.bind(this)}
                        />
                        {!preliminarySection &&
                        <PlaceholderLink allowPreliminary={allowPreliminary} preliminary={preliminary}
                                         onClick={this.onTogglePreliminary.bind(this)}/>}
                    </div>
                );
            case "date":
                let date;
                if (value === undefined) {
                    date = undefined;
                } else {
                    date = new Date(value);
                }
                return (
                    <div className={className}>
                        <label className={labelClassName}><ReactMarkdown allowedElements={['strong', 'em', 'a']}
                                                                         unwrapDisallowed={true}>{label}</ReactMarkdown></label>
                        <Explanation explanation={explanation}/>
                        <SemanticDatepicker autoFocus={focused} value={date} firstDayOfWeek={1}
                                            onChange={this.onDateChange.bind(this)}/>
                    </div>
                );
            case "dropdown":
                let placeHolder = 'Choose an option';
                if (allowAdditions) {
                    placeHolder = 'Choose an option or type a new value';
                    if (value) {
                        // check we have options for all values
                        if (multiple) {
                            for (let i = 0; i < value.length; i++) {
                                if (!uniqueOptionsValues.has(value[i])) {
                                    options.push({text: value[i], value: value[i]})
                                }
                            }
                        } else {
                            if (!uniqueOptionsValues.has(value)) {
                                options.push({text: value, value: value});
                            }
                        }
                    }
                }

                return (
                    <div className={className}><label className={labelClassName}>
                        <ReactMarkdown allowedElements={['strong', 'em', 'a']}
                                       unwrapDisallowed={true}>{label}</ReactMarkdown></label> <Explanation
                        explanation={explanation}/>
                        <Dropdown searchInput={{autoFocus: focused}}
                                  error={error !== undefined}
                                  value={value}
                                  openOnFocus={false}
                                  onChange={this.onValueChange.bind(this)} selection
                                  options={options}
                                  placeholder={placeHolder}
                                  search
                                  multiple={multiple}
                                  allowAdditions={allowAdditions}
                                  onAddItem={allowAdditions ? this.onValueAdded.bind(this) : undefined}

                        />
                        {error && <Label prompt pointing>{error}</Label>}
                        {!preliminarySection &&
                        <PlaceholderLink allowPreliminary={allowPreliminary} preliminary={preliminary}
                                         onClick={this.onTogglePreliminary.bind(this)}/>}
                    </div>
                );
        }
        return null;
    }

}